export default __webpack_public_path__ + "static/media/CamFollowersImg.9a4a4876.jpg";